import React from 'react';
import { CommonPrelanderV41 } from '../../components/CommonPrelanderV41';
import { QUIZ_SLIDES_V31 } from '../../shared/quiz-slides/quiz-slides-v31';

function PrelanderV50Page({ initialPrelander }) {
    return (
        <CommonPrelanderV41
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V31}
        />
    );
}

export {
    PrelanderV50Page
};
